export const PRODUCT_ID_NEW = 'new';

export const PRODUCT_NAME_ATOL_MAX_LENGTH = 128;

export const PRODUCTS_DASHBOARD_TABS_MAP = {
    cards: 'cards',
    allVariants: 'all-variants',
    moderation: 'moderation',
    archivedVariants: 'archived-variants',
} as const;
